export default "__VITE_ASSET__DVmq0U9k__"